import { g as r } from "./utils.CjOCBPlS.js";
const g = (o) => r(o);
export {
  g as r
};
//# sourceMappingURL=useDataAnalytics.D6N2koT1.js.map
